export default __webpack_public_path__ + "static/media/icone-comentarios.07d33789.svg";